export enum HttpCustomHeaderEnum {
    Skip_Error_Handling = 'X-Skip-Error-Handling'
}